import * as types from "../constants/action-types";

export function toggleMenu() {
  return {
    type: types.TOGGLE_MENU
  };
}

export function closeMenu() {
  return {
    type: types.CLOSE_MENU
  };
}



// WEBPACK FOOTER //
// ./src/actions/ui.js